import { useEffect, useState } from "react";
import { SelectSearcher } from "../../Abstractions/MultiSearcher/SelectSearcher";
import { KeoCardDescriptionProvider } from "./KeoCardDescriptionProvider";

export function KeoBdoCodeSelect({ name, kpoCardWasteCode, keoItems }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getInitialKeoItems(kpoCardWasteCode, keoItems));
  }, [keoItems]);

  return (
    <>
      <SelectSearcher
        name={name}
        label="Karta KEO"
        items={items}
        onSearchChange={() => {}}
        optionsObject={{ key: "keoId", value: "description" }}
        placeholder="Szukaj"
        required
        saveWholeObject
        hideSearcher
      />
    </>
  );
}

const getInitialKeoItems = (kpoCardWasteCode, keoItems) => {
  return keoItems?.filter(x => x.wasteCode.includes(kpoCardWasteCode))
  .map(x => ({ keoId: x.keoId, description: KeoCardDescriptionProvider.getDescription(x) })) ?? [];
}